import { ContentLayout, Header } from "@amzn/awsui-components-react";
import { FC } from "react";
import Layout from "../../layout/Layout";

const StylesheetViz: FC<any> = () => {
    return (
        <Layout>
            <ContentLayout header={<Header variant="h1">Visualization</Header>}>
                <>Stylesheet Visualization</>
            </ContentLayout>
        </Layout>
    )
}
export default StylesheetViz;